export const DEMO_PROPERTY_ID = 11080502;

export const isDemoProperty = (propertyId: number): boolean => {
  return propertyId === DEMO_PROPERTY_ID;
};